// // components/FleetHighway.jsx
// import React from "react";
// import "../css/FleetHighway.css";

// const cars = [
//   "/images/fleet/Innova-Cab.jpg",
//   "/images/fleet/Innova-Crysta.jpg",
//   "/images/fleet/Kia-Carens.jpg",
//   "/images/fleet/Tempo-Traveller.jpg",
//   "/images/fleet/Urbania-Bus.jpeg",
// ];

// const FleetHighway = () => {
//   // duplicate to create seamless loop
//   const lane = [...cars, ...cars];

//   return (
//     <section className="highway-wrap">
//       <h2 className="fleet-title">Our Fleets</h2>

//       {/* LANE 1 → */}
//       <div className="lane lane-top">
//         <div className="lane-track">
//           {lane.map((src, i) => (
//             <figure className="car-card" key={`t-${i}`}>
//               <img src={src} alt={`Fleet ${i + 1}`} />
//               <figcaption>Trustline Travels</figcaption>
//             </figure>
//           ))}
//         </div>
//       </div>

//       {/* LANE 2 ← */}
//       <div className="lane lane-bottom">
//         <div className="lane-track">
//           {lane.map((src, i) => (
//             <figure className="car-card" key={`b-${i}`}>
//               <img src={src} alt={`Fleet ${i + 1}`} />
//               <figcaption>Trustline Travels</figcaption>
//             </figure>
//           ))}
//         </div>
//       </div>

//       {/* dotted center divider */}
//       <div className="center-divider" />
//     </section>
//   );
// };

// export default FleetHighway;

// components/FleetHighway.jsx
import React from "react";
import "../css/FleetHighway.css";

const cars = [
  {
    image: "/images/fleet/Innova-Cab.jpg",
    name: "Toyota Innova",
  },
  {
    image: "/images/fleet/Innova-Crysta.jpg",
    name: "Toyota Innova Crysta",
  },
  {
    image: "/images/fleet/Kia-Carens.jpg",
    name: "Kia Carens",
  },
  {
    image: "/images/fleet/Tempo-Traveller.jpg",
    name: "Tempo Traveller",
  },
  {
    image: "/images/fleet/Urbania-Bus.jpeg",
    name: "Force Urbania",
  },
];

const FleetHighway = () => {
  // Duplicate to create seamless loop
  const lane = [...cars, ...cars];

  return (
    <section className="highway-wrap">
      <h2 className="fleet-title">Our Fleets</h2>

      {/* LANE 1 → */}
      <div className="lane lane-top">
        <div className="lane-track">
          {lane.map((car, i) => (
            <figure className="car-card" key={`t-${i}`}>
              <img
                src={car.image}
                alt={car.name}
              />
              <figcaption>{car.name}</figcaption>
            </figure>
          ))}
        </div>
      </div>

      {/* LANE 2 ← */}
      <div className="lane lane-bottom">
        <div className="lane-track">
          {lane.map((car, i) => (
            <figure className="car-card" key={`b-${i}`}>
              <img
                src={car.image}
                alt={car.name}
              />
              <figcaption>{car.name}</figcaption>
            </figure>
          ))}
        </div>
      </div>

      {/* Dotted center divider */}
      <div className="center-divider" />
    </section>
  );
};

export default FleetHighway;